import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

/**
 * - 로그인 화면으로 이동 (현재 화면을 로그인 화면으로 대체)
 * - redirect: 로그인 성공 후 돌아갈 페이지 (웹에서 /login?redirect= 로 전달)
 */
export const useMoveToLogin = () => {
  const navigation = useRootStackNavigation();

  return useCallback(
    (redirect?: string) => {
      navigation.replace('Login', redirect ? { redirect } : {});
    },
    [navigation],
  );
};
